import IconButton from "components/IconButton"
import { onlyNumbers } from "services/Utils"
import { formatNumber } from "services/Utils"

const DifPercentual = ({ valor }) => (
  <span style={{ color: valor < 0 ? 'red' : 'green' }}>{formatNumber(valor)}%</span>
)

export default function Item(props) {
  const { id, codigo, descricao, unidade, precoUnitario, precoUnitarioFmt, quantidadeContratada, quantidadeContratadaFmt, valorTotal, valorTotalFmt, filhos, itens,
    alteracoes, selecionados, onChangePrecoUnitario, onChangeQuantidade, onChangeSelecao
  } = props

  const tipo = (!!itens || !!filhos) ? 'grupo' : 'item'

  const handleChangeNovoPrecoUnitario = ev => {
    const valor = ev.target.value
    if (valor == '')
      onChangePrecoUnitario && onChangePrecoUnitario(id, null)
    else
      onChangePrecoUnitario && onChangePrecoUnitario(id, parseInt(onlyNumbers(valor)) / 100)
  }

  const handleChangeNovaQuantidade = ev => {
    const valor = ev.target.value
    if (valor == '')
      onChangeQuantidade && onChangeQuantidade(id, null)
    else
      onChangeQuantidade && onChangeQuantidade(id, parseInt(onlyNumbers(valor)) / 100)
  }

  const handleChangeSelecionado = (selecionar) => {
    onChangeSelecao && onChangeSelecao(id, selecionar)
  }

  if (tipo === 'grupo') {
    return (
      <>
        <tr className="grupo" key={id}>
          <td>{codigo}</td>
          <td colSpan={9} className="text-wrap">{descricao}</td>
        </tr>
        {itens.map(el => (
          <Item
            alteracoes={alteracoes}
            selecionados={selecionados}
            key={el.id}
            {...el}
            onChangePrecoUnitario={onChangePrecoUnitario}
            onChangeQuantidade={onChangeQuantidade}
            onChangeSelecao={onChangeSelecao}
          />
        ))}
        {filhos.map(el => (
          <Item
            alteracoes={alteracoes}
            selecionados={selecionados}
            key={el.id}
            {...el}
            onChangePrecoUnitario={onChangePrecoUnitario}
            onChangeQuantidade={onChangeQuantidade}
            onChangeSelecao={onChangeSelecao}
          />
        ))}
      </>
    )
  } else if (tipo == 'item') {
    const alteracao = alteracoes?.find(el => el.id == id)
    const selecionado = selecionados?.includes(id)

    const precoUnitarioConsiderado = (alteracao && alteracao.novoPrecoUnitario) ? alteracao.novoPrecoUnitario : precoUnitario
    const quantidadeConsiderada = (alteracao && alteracao.novaQuantidade) ? alteracao.novaQuantidade : quantidadeContratada
    const valorTotalConsiderado = precoUnitarioConsiderado * quantidadeConsiderada

    return (
      <>
        <tr key={id}>
          <td rowSpan={2} className="align-middle">{codigo}</td>
          <td className="text-muted"><em>(Ver descrição abaixo)</em></td>
          <td>{unidade}</td>
          <td className="text-right">R$ {precoUnitarioFmt}</td>
          <td className="text-right">{quantidadeContratadaFmt}</td>
          <td className="text-right">R$ {valorTotalFmt}</td>
          <td className="text-right">
            <input
              type="text"
              className="form-control"
              value={(alteracao && alteracao.novoPrecoUnitario) ? formatNumber(alteracao.novoPrecoUnitario) : ''}
              onChange={handleChangeNovoPrecoUnitario}
              disabled={!selecionado}
            />
            {(alteracao && alteracao.novoPrecoUnitario) && (
              <DifPercentual valor={(alteracao.novoPrecoUnitario / precoUnitario - 1) * 100} />
            )}
          </td>
          <td className="text-right">
            <input
              type="text"
              className="form-control"
              value={(alteracao && alteracao.novaQuantidade) ? formatNumber(alteracao.novaQuantidade) : ''}
              onChange={handleChangeNovaQuantidade}
              disabled={!selecionado}
            />
            {(alteracao && alteracao.novaQuantidade) && (
              <DifPercentual valor={(alteracao.novaQuantidade / quantidadeContratada - 1) * 100} />
            )}
          </td>
          <td className="text-right">
            <div>R$ {formatNumber(valorTotalConsiderado)}</div>
            {(alteracao && (alteracao.novoPrecoUnitario || alteracao.novaQuantidade)) && (
              <DifPercentual valor={(valorTotalConsiderado / valorTotal - 1) * 100} />
            )}
          </td>
          <td>
            <div className="d-flex align-items-center mb-0 gap-5px">
              <div>
                Alterar
              </div>
              <label className="custom-toggle" style={{ marginBottom: 0 }}>
                <input type="checkbox" checked={selecionado} onChange={() => handleChangeSelecionado(!selecionado)} />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
            </div>
          </td>
        </tr>
        <tr className="item-descricao-row">
          <td colSpan={9} className="item-descricao-content">{descricao}</td>
        </tr>
      </>
    )
  }
}
